import React, { useMemo, useState } from 'react'

import { Select } from 'antd'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'

const { Option } = Select

const CURRENT_YEAR = moment().year()
const DATES = Array.from({ length: 31 }, (v, i) => i + 1)
const MONTHS = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december']
const YEARS = Array.from({ length: 100 }, (v, i) => CURRENT_YEAR - i)

const BirthdatePicker = ({ value, disabled, onChange }) => {
  const t = useSelector(selectTranslate)

  const [dateParts, setDateParts] = useState(value ? value.split('/').map(s => Number(s)) : [null, null, null])

  const handleChange = (value, index) => {
    const newDateParts = dateParts.map((part, i) => i === index ? value : part)

    setDateParts(newDateParts)

    if (newDateParts.every(p => p)) {
      onChange(moment(newDateParts.join('-'), 'DD-MM-YYYY'))
    }
  }

  const dateOptions = useMemo(() => DATES.map(i => <Option key={i} value={i}> {i} </Option>), [])
  const monthOptions = useMemo(() => MONTHS.map((m, index) => <Option key={m} value={index + 1}> {t(m)} </Option>), [t])
  const yearOptions = useMemo(() => YEARS.map(y => <Option key={y} value={y}> {y}</Option>), [])

  return (
    <div className='flex-row'>
      <Select style={{ width: '60px', marginLeft: '4px' }} value={dateParts[0]} onChange={value => handleChange(value, 0)} disabled={disabled}>{dateOptions}</Select>
      <Select style={{ width: '130px', marginLeft: '4px' }} value={dateParts[1]} onChange={value => handleChange(value, 1)} disabled={disabled}>{monthOptions}</Select>
      <Select style={{ width: '80px', marginLeft: '4px' }} value={dateParts[2]} onChange={value => handleChange(value, 2)} disabled={disabled}>{yearOptions}</Select>
    </div>
  )
}

export default BirthdatePicker
